import { useEffect, useState } from "react";
//import FeatherIcons from "feather-icons-react";
import { api } from "@/apps/common/api-client";
import { useAuthStore } from "@/apps/common/store/useAuthStore";
import { Stack, Form, Alert, ButtonToolbar, Button, Card, Container, Row, Col, ToggleButtonGroup, ToggleButton, Modal, ModalDialog } from "react-bootstrap";
import { useRequest } from "ahooks";
import GridSystem from "@/apps/common/components/GridSystem"
import { SimulatedSessionType, UserSettingsType } from "@/apps/common/types/appointment-types";
import AudioPlayer from "@/apps/common/components/AudioPlayer";
import '@/assets/scss/custom/pages/_simulated-session.scss'
import { FcBookmark } from "react-icons/fc";
//import playButton from "@assets/images/icons/icons8-circled-play-office-xs-32.png"
import playButton from "@assets/images/icons/icons8-circled-play-32.png"
//import userTherapySessionProgressIcon from "@assets/images/icons/icons8-checkmark-puffy-filled-16.png"
//import userTherapySessionCompletedIcon from "@assets/images/icons/icons8-double-checkmark-neu-16.png"
import testAudio from "@assets/audio/test.mp3"
import { FcCheckmark } from "react-icons/fc";
import { FcSurvey } from "react-icons/fc";
import { FcCalendar } from "react-icons/fc";
import { ThoughtJournalType, UserSessionLibraryType } from "@apps/common/types/appointment-types"
import { FiHeadphones } from "react-icons/fi";
import { IoCheckmarkDoneSharp } from "react-icons/io5";

//import { v4 as uuidv4 } from 'uuid';



const SimulatedSessions = () => {

  const [simulatedSessions, setSimulatedSessions] = useState<SimulatedSessionType[]>([]);
  const [sessionTags, setSessionTags] = useState<Set<string>>(new Set());
  const [selectedTags, setSelectedTags] = useState<Set<string>>(new Set(["All"]));
  const [filteredSessions, setFilteredSessions] = useState<SimulatedSessionType[]>([])
  const [selectedSession, setSelectedSession] = useState<SimulatedSessionType>()
  const [showAudioPlayer, setShowAudioPlayer] = useState<boolean>(false)
  const [thoughtJournal, setThoughtJournal] = useState<ThoughtJournalType>()
  const [enableSaveThoughtBtn, setEnableSaveThoughtBtn] = useState<boolean>(false)
  const [userTherapySessions, setUserTherapySessions] = useState<UserSessionLibraryType[] | null>(null)
  const [userTherapySession, setUserTherapySession] = useState<UserSessionLibraryType>()
  const [userSettings, setUserSettings] = useState<UserSettingsType>()
  const [thought, setThought] = useState('');
  const [showThoughtJournal, setShowThoughtJournal] = useState<boolean>(false);
  const [thoughtJournalAlertMessage, setThoughtJournalAlertMessage] = useState<string>('')
  const [displayThoughtJournalAlert, setDisplayThoughtJournalAlert] = useState<boolean>(false)

  const { user } = useAuthStore();

  async function fetchUserSettings() {

    ////console.debug (`Fetching userSettings for ${user?.id}`)
    if (user?.id) {
      const userSettings = await api.userSettings.getByUserId(user?.id)
      ////console.debug(`userSettings ${JSON.stringify(userSettings)}`)
      if (userSettings) {
        setUserSettings(userSettings)
      }
      else {

        // create userSettings for this user.
        const data = {}
        api.userSettings.create(data).then((res) => { setUserSettings(res) })

      }
    }
  }

  const {
    run: _fetchUserSettings
  } = useRequest(fetchUserSettings,
    {
      manual: true
    }
  );

  async function fetchAllUserSessions() {

    if (userSettings?.id) {
      ////console.debug(`Fetching All User Therapy Sessions for userSettings - ${userSettings.id}`)
      const userSessions = await api.userSessionLibrary.findAllUserSessions(userSettings?.id)
      ////console.debug(`useSessions ${JSON.stringify(userSessions)}`)
      if (userSessions.length > 0) {
        ////console.debug(`Setting userTherapy Sessions - ${userSessions.length}`)
        setUserTherapySessions([...userSessions])
      }
    }
  }

  const {
    run: _fetchAllUserSessions
  } = useRequest(fetchAllUserSessions,
    {
      manual: true
    }
  );

  async function createUserTherapySession() {
    const data = {
      user_setting: userSettings?.id,
      simulated_session: selectedSession!.id
    };

    if (user?.id) {
      const userTherapySession = await api.userSessionLibrary.create(data)
      ////console.debug(`userTherapySession ${JSON.stringify(userTherapySession)}`)
      setUserTherapySession(userTherapySession)
    }
  }
  const {
    run: _createUserTherapySession
  } = useRequest(createUserTherapySession,
    {
      manual: true
    }
  );

  // function containsTags(mainArray: any[], subArray: any[]): boolean {
  //   return subArray.every(element => mainArray.includes(element));
  // }
  function containsAnyTag(arr1: any[], arr2: any[]): boolean {
    return arr1.some(element => arr2.includes(element));
  }

  useEffect(() => {
    ////console.debug('useEffect empty')
    _fetchSessions()
    _fetchUserSettings()
    //_fetchAllUserSessions()

  }, []);

  useEffect(() => {
    ////console.debug('useEffect userSettings')

    _fetchAllUserSessions()

  }, [userSettings]);

  useEffect(() => {
    _fetchAllUserSessions()
    // const sessions = userTherapySessions.map((session) => session)
    // setUserTherapySessions(sessions)
  }, [userTherapySession]);

  useEffect(() => {
    ////console.debug(`useEffect selectedTags ... ${Array.from(selectedTags)}`)
    if (selectedTags?.size === 0) {
      //console.debug(`No Tag Selected`)
      setFilteredSessions([])
      return
    }

    if (selectedTags?.has('All')) {
      setFilteredSessions(simulatedSessions)
      return
    }

    const _selectedSessions: SimulatedSessionType[] = []

    simulatedSessions.forEach((session) => {
      const sessionTags: string[] = []
      ////console.debug(`session - ${JSON.stringify(session)}`)
      session?.tags?.forEach((tag) => {
        if (tag?.name) sessionTags.push(tag?.name);
      })

      ////console.debug(`val - ${JSON.stringify(selectedTags)}`)
      if (containsAnyTag(sessionTags, Array.from(selectedTags))) {
        ////console.debug(`selected session ${session?.title}`)
        _selectedSessions.push(session)
      }

    })

    ////console.debug(`Filtered simulated sessions - ${_selectedSessions.length}`)
    setFilteredSessions(_selectedSessions)

  }, [selectedTags]);


  useEffect(() => {
    //console.debug(`useEffect selectedSession - ${selectedSession?.id}`)
    if (selectedSession) {

      _fetchThoughtJournal()

      // Find the userTherapySession
      const _userTherapySession = userTherapySessions?.find((session) => {
        ////console.debug (`session - ${JSON.stringify(session)}`)
        if ((session?.simulated_session?.id === selectedSession.id) && (session.user_setting.id === userSettings?.id)) {
          //console.debug(`userTherapySession Found - ${session.id}`)
          return session
        }
      })

      if (!_userTherapySession) {
        // Create a new UserTherapySession Its for the Librsry
        _createUserTherapySession()
        _fetchAllUserSessions()
      }
      else {
        ////console.debug(`setting User Therapy Session - ${JSON.stringify(_userTherapySession)}`)
        setUserTherapySession(_userTherapySession)
      }

      setShowAudioPlayer(true)
    }
    //_fetchSessions()
  }, [selectedSession]);

  async function fetchAllSessions() {
    const memberServices = await api.memberServices.findMany()
    const sessions = await api.simulatedSession.fetchAllSessions()
    const tagSet: Set<string> = new Set()
    tagSet.add('All')
    setSimulatedSessions([])
    setFilteredSessions([])
    sessions.forEach((session) => {

      memberServices.forEach((memberService) => {
        if (memberService?.id === session?.memberService?.id) {
          //console.debug (`Skipping this simulatedSession - ${session?.id} for member - ${user?.firstName} ${user?.lastName}`)
          return
        }
      })

      if (session?.audio?.url) {
        setSimulatedSessions(prev => [...prev, session])
        setFilteredSessions(prev => [...prev, session])
        ////console.debug(`session - ${JSON.stringify(session)}`)
        // Add all the sessionTags too 
        ////console.debug (`Tags - ${JSON.stringify(session?.tags)}`)
        session?.tags?.forEach((tag) => {
          ////console.debug(`tag - ${tag?.tag}`)
          if (tagSet.has(tag?.name) === false) {
            ////console.debug (`adding a new tag to the set`)
            tagSet.add(tag?.name);
          }
          ////console.debug(`tagSet - ${JSON.stringify(Array.from(tagSet))}`)
        })
      }

      ////console.debug(`Tags - ${JSON.stringify(sessionTags)}`)
    })
    ////console.debug(`tagSet - ${JSON.stringify(Array.from(tagSet))}`)

    setSessionTags(tagSet)
  }

  async function fetchThoughtJournal() {
    //console.debug(`Fetching thought journal for user - ${user?.id} and session - ${selectedSession?.id}`)
    let thoughtJournals: ThoughtJournalType[] = [];
    if ((user?.id) && (selectedSession?.id))
      thoughtJournals = await api.thoughtJournal.findThoughtJournal(user?.id, selectedSession?.id)

    if (thoughtJournals?.length > 0) {
      //console.debug(`Found Thought Journal ${thoughtJournals[0].thought}`)
      //setCreateJournal(false)
      setThoughtJournal(thoughtJournals[0])
      setThought(thoughtJournals[0].thought)
    }
  }

  const { data: _thoughtJournals = [], run: _fetchThoughtJournal } = useRequest(
    fetchThoughtJournal,
    {
      refreshDeps: [selectedSession]
    }
  );

  const { loading: saving, data: _invoices = [], runAsync: _fetchSessions } = useRequest(
    fetchAllSessions,
    {
      manual: true
    }
  );

  const handleCardClick = async (event: any) => {
    //const elementId = event.target.id;

    //console.debug(`Element ID: ${event.currentTarget.id} showAudioPlayer - ${showAudioPlayer}`);
    setShowThoughtJournal(false)
    setThought('')
    setThoughtJournal(undefined)
    setShowAudioPlayer(false)
    const _selectedSession = filteredSessions.find((session) => {
      ////console.debug(`session - ${JSON.stringify(session)}`)
      if (session?.id == event.currentTarget.id) {
        ////console.debug(`Found the`)
        return session
      }
    })

    // refresh UserTherapySession too
    let _userTherapySessions = null;
    if ((userSettings?.id) && (_selectedSession?.id))
      _userTherapySessions = await api.userSessionLibrary.findUserSession(userSettings?.id, _selectedSession?.id).then(

        (res) => {
          //console.debug(`Setting User Therapy Session - ${JSON.stringify(res)}`)
          if (res.length > 0)
            setUserTherapySession(res[0])
        })

    // if ((_userTherapySessions?.length > 0)  && (_userTherapySessions)){
    //   //console.debug(`Setting User Therapy Session - ${JSON.stringify(_userTherapySessions[0])}`)
    //   setUserTherapySession(_userTherapySessions[0])
    // } 

    //console.debug(`selectedSession for playing - ${JSON.stringify(_selectedSession?.id)} userTherapySession - ${JSON.stringify(userTherapySession)}`)
    // if (_selectedSession?.id === selectedSession?.id){
    //   setShowAudioPlayer(true)
    // }


    if (_selectedSession)
      setSelectedSession({ ..._selectedSession })


    //setShowAudioPlayer(true)

  };

  function findUserTherapySession(sessionId: number): any {

    let _userTherapySession;
    if (userTherapySessions) {
      ////console.debug (`finding User Therapy Session for Simulated Session - ${sessionId}`)
      _userTherapySession = userTherapySessions.find((session) => {
        if (session?.simulated_session?.id === sessionId) {

          return session
        }
      })
      if (!_userTherapySession)
        return null
      else {
        ////console.debug (`FOUND - ${JSON.stringify(_userTherapySession)}`)
        return _userTherapySession
      }
    }
  }

  // function findCardColor(sessionId: number): string {

  //   const _userTherapySession = userTherapySessions.find((session) => {
  //     if (session?.simulated_session?.id === sessionId) {
  //       return session
  //     }
  //   })


  //   if ((_userTherapySession?.progress === 0) || (!_userTherapySession)) {
  //     return "#ebeadf"
  //   }
  //   if (_userTherapySession?.progress > 0) {
  //     return "#7ecc97"
  //   }

  //   return "#ebeadf"

  // }

  const Item = (props: any) => {
    //destrcture the props
    ////console.debug(`props - ${JSON.stringify(props)}`)
    const { id, title, audio, tags, userTherapySession } = props
    ////console.debug(`userTherapySession - ${JSON.stringify(userTherapySession)} for session - ${id}`)

    return (
      // <Card style={{ "background": findCardColor(props.id) }} id={props.id} onClick={handleCardClick} className='d-flex align-items-stretch align-self-stretch flex-fill'>
      <Card
        key={id}
        style={{
          "background": (userTherapySession?.progress === "0") || (userTherapySession === null) || (userTherapySession === undefined) ? "#ebeadf" : "#7ecc97",
          "height": "150px",
        }}
        id={props.id}
        onClick={handleCardClick}
        className='flex-fill overflow-scroll' >
        {/* <Card.Header>{title}</Card.Header> */}
        <Card.Body >
          <div className="" style={{ fontFamily: "arial", fontSize: "small" }}>
            {/* {tags.slice(0, 3).map((tag: any, index: any) => <div className="flex-grow-1" key={index}><FcBookmark /> {tag?.['name']}</div>)} */}
            {tags.slice(0, 3).map((tag: any, index: any) => <><FcBookmark /> {tag?.['name']}</>)}

          </div>
          <div style={{ fontFamily: "arial", fontSize: "medium" }}>
            <img src={playButton} rel="icon" />
            <strong >
              {title}
            </strong>

            {!userTherapySession?.completed_session && userTherapySession?.createdAt ? (
              <div style={{ fontFamily: "arial", fontSize: "x-small" }}>
                {/* <img src={userTherapySessionProgressIcon} /> */}
                <FiHeadphones size={18} className="me-1" />
                <strong >
                  Started Listening on: {new Date(userTherapySession?.createdAt)?.toDateString()}
                </strong>
              </div>) : null
            }
            {userTherapySession?.completed_session ? (
              <div style={{ fontFamily: "arial", fontSize: "x-small" }}>
                {/* <img src={userTherapySessionCompletedIcon} /> */}
                <IoCheckmarkDoneSharp size={18} className="me-1" />
                <strong>
                  {new Date(userTherapySession?.completed_session)?.toDateString()}
                </strong>
              </div>) : null
            }
          </div>
        </Card.Body>
      </Card>
    )
  }
  // const Item = (props: any) => {
  //   //destrcture the props
  //   ////console.debug(`props - ${JSON.stringify(props)}`)
  //   const { id, title, audio, tags, userTherapySession } = props
  //   //console.debug(`userTherapySession - ${JSON.stringify(userTherapySession)} for session - ${id}`)

  //   return (
  //       <div style={{"width":"50%"}}>

  //         <div style={{ fontFamily: "arial", fontSize: "small" }}>
  //           {tags.slice(0, 3).map((tag: any, index: any) => <><FcBookmark /> {tag?.['name']}</>)}
  //         </div>
  //         <div style={{ fontFamily: "arial", fontSize: "medium" }}>
  //           <img src={playButton} rel="icon" />
  //           <strong >
  //             {title}
  //           </strong>

  //           {userTherapySession?.id ? (
  //             <div style={{ fontFamily: "arial", fontSize: "small" }}>
  //               <strong>
  //                 Started Listening on: {new Date(userTherapySession?.createdAt)?.toDateString()}
  //               </strong>
  //             </div>) : null
  //           }
  //         </div>
  //         </div>

  //   )
  // }

  const showThoughtJournalAlert = () => {
    setDisplayThoughtJournalAlert(true);
    setTimeout(() => {
      setDisplayThoughtJournalAlert(false);
      setShowThoughtJournal(false)

    }, 2000);
  };

  const saveThoughtJournal = async () => {
    //console.debug(`Saving thought in journal ${user?.id}`)
    setEnableSaveThoughtBtn(false)
    const data = {
      user: user!.id,
      thought: thought,
      simulated_session: selectedSession!.id
    };

    if (!thoughtJournal) {
      await api.thoughtJournal.create(data).then(
        (res) => {
          //console.debug(`successfuly save the thought`);
          setThoughtJournalAlertMessage('Your thougth was successfully saved in your journal!');
          showThoughtJournalAlert()
        },
        (err) => {
          console.error(`error saving the thought`)
          setThoughtJournalAlertMessage('An error occurred while saving your thougth in your journal! Please try again.');
          showThoughtJournalAlert()
        }
      )
    }
    else {
      const data = {
        thought: thought,
      }
      api.thoughtJournal.update(thoughtJournal.id, data).then(
        (res) => {
          //console.debug(`successfuly save the thought`);
          setThoughtJournalAlertMessage('Your thougth was successfully saved in your journal!');
          showThoughtJournalAlert()
        },
        (err) => {
          console.error(`error saving the thought`)
          setThoughtJournalAlertMessage('An error occurred while saving your thougth in your journal! Please try again.');
          showThoughtJournalAlert()
        }
      )
    }

  }

  const onPlaybackEnded = () => {
    //console.debug(`Playback had ended`)
    if (userTherapySession) {
      const data = {
        completed_session: new Date()
      }
      api.userSessionLibrary.update(userTherapySession.id, data).then(
        (res) => {
          //console.debug(`Audio Session Progress updated - ${JSON.stringify(res)}`)
          const _sessions = userTherapySessions?.map((session) => {

            if (session.id === res.id) {
              // Update the data for this session
              return res

            }
            return session

          })

          if (_sessions !== undefined)
            setUserTherapySessions([..._sessions])
          setUserTherapySession(res)
        }
      )
    }

  }

  const onPlaybackUpdate = (currentPlaybackTime: number) => {
    //console.debug(`Current Audio Time - ${currentPlaybackTime} for ${userTherapySession?.id}`)
    if (userTherapySession) {
      const data = {
        progress: Math.round(currentPlaybackTime)
      }
      api.userSessionLibrary.update(userTherapySession.id, data).then(
        (res) => {
          //console.debug(`Audio Session Progress updated - ${JSON.stringify(res)}`)
          const _sessions = userTherapySessions?.map((session) => {

            if (session.id === res.id) {
              // Update the data for this session
              return res

            }
            return session

          })

          if (_sessions !== undefined)
            setUserTherapySessions([..._sessions])
          setUserTherapySession(res)
        }
      )
    }
  }

  const [showTherapySessionInfo, setShowTherapySessionInfo] = useState<boolean>(false)

  return (
    <>
      {sessionTags.size > 0 ? (
        <Card className='mt-2' style={{ "display": "flex", "height": '250px', 'overflowY': 'scroll' }}>
          <Card.Body>
            {(simulatedSessions.length > 0) ? (
              <>
                <div style={{ fontFamily: "Arial", fontSize: "x-large" }}>
                  <strong>What Challenges are your facing ?</strong>
                  <br />

                </div>
                <div style={{ fontFamily: "arial", fontSize: "small" }}> Choose as many as you like</div>
                <Container fluid="md" flex-wrap="wrap" style={{ "display": "flex" }}>
                  <Row>

                    <ToggleButtonGroup type="checkbox" className="mb-2" value={Array.from(selectedTags)} style={{ flexWrap: 'wrap' }}>
                      {Array.from(sessionTags).map((session, index) => {
                        return (
                          <ToggleButton key={session} className="btn btn-sm tag-button rounded-pill m-1" type="checkbox" id={session} value={session}
                            onChange={
                              (event) => {
                                ////console.debug(`ToggleButton value - ${JSON.stringify(event.target.value)} ${event.target.checked}`);
                                setFilteredSessions([])
                                if ((event.target.checked) && (event.target.value === "All")) {
                                  ////console.debug(`All is selected`)
                                  const _selectedTags = new Set(["All"])
                                  setSelectedTags(_selectedTags)
                                  //{setLastClickedTag(event.target.value)} 
                                }
                                else if ((event.target.checked) && (event.target.value !== "All")) {
                                  const _selectedTags = new Set(Array.from(selectedTags));
                                  ////console.debug(`selectedTags - ${Array.from(_selectedTags)}`)
                                  if (_selectedTags.has('All')) {
                                    _selectedTags.delete('All')
                                  }
                                  _selectedTags.add(event.target.value)
                                  ////console.debug(`after processing - ${Array.from(_selectedTags)}`)
                                  setSelectedTags(_selectedTags)

                                }
                                else if ((event.target.checked === false)) {
                                  ////console.debug (`selectedTags - ${Array.from (selectedTags)}`)
                                  const _selectedTags = new Set(Array.from(selectedTags))
                                  ////console.debug (`trying to delete ${event.target.value}`)
                                  _selectedTags?.delete(event.target.value)
                                  if (_selectedTags.size === 0)
                                    _selectedTags.add('All')
                                  setSelectedTags(_selectedTags)
                                }
                                // else if (event.target.checked === false)
                                //   setLastClickedTag('')

                              }}> {session} </ToggleButton>
                          // <ToggleButton style={styles.tagButton} className="tag-button rounded-pill m-1" type="checkbox" id={session} value={session}> {session} </ToggleButton>
                        )
                      })
                      }
                    </ToggleButtonGroup>
                  </Row>




                </Container>
                <div>

                  <a href='#' onClick={() => setShowTherapySessionInfo(true)} style={{ fontFamily: "arial", fontSize: "small" }}>What are Listen Therapy sessions?</a>
                  <Modal show={showTherapySessionInfo} onHide={() => setShowTherapySessionInfo(false)}>
                    <Modal.Header closeButton><strong>What are Listen Therapy sessions</strong></Modal.Header>
                    <Modal.Body>
                      These sessions are pre-recorded, <strong>simulated audio therapy sessions generated using AI</strong>, conducted between counselors and patients to provide insight into how to manage and navigate various mental and behavioral health challenges. These are not intended to be used to diagnose, treat, or prevent medical/mental health conditions or identify emergencies. You may access and listen to these sessions only in accordance with these <a href='https://skylerhealth.com/tou' target='_blank'>Terms of Use</a> and <a href='https://skylerhealth.com/privacy-policy' target='_blank'>Privacy Policy</a>.
                    </Modal.Body>
                  </Modal>


                </div>

              </>) : null}

          </Card.Body>

        </Card>) : null}

      {
        filteredSessions.length > 0 ? (
          <>
            <Card className='d-flex mt-1' style={{ 'overflowY': 'scroll' }}>
              <Card.Body>
                <Container fluid="md" className="d-flex" >
                  {/* <Container fluid="md" className="d-flex flex-fill" > */}
                  <GridSystem colCount={2} md={6}>
                    {filteredSessions.length > 0 ? filteredSessions.map(item =>
                      <Item
                        key={item.id}
                        id={item.id}
                        title={item.title}
                        audio={item?.audio?.url}
                        tags={item.tags}
                        userTherapySession={findUserTherapySession(item.id)} />) : [<p>No Sessions.</p>]}
                  </GridSystem>
                </Container>
              </Card.Body>
            </Card>
          </>


          // <Card >
          //   {buildGrid()}
          // </Card>


        ) : null
      }
      {
        userTherapySession?.id ? (
          <Modal
            show={!!showAudioPlayer}
            onHide={() => {
              setShowAudioPlayer(false);
              setShowThoughtJournal(false)
              setThought('')
              _fetchAllUserSessions()
            }}
            // onClose={() => {
            //   setShowAudioPlayer(false);
            //   setShowThoughtJournal(false)
            //   setThought('')
            // }}
            size="lg"
            scrollable={true}
            //style={{'boxSizing': 'border-box'}}
            className="d-flex overflow-auto"

          >
            <Modal.Header closeButton className="pb-0 mb-0">
              {/* <text style={{ fontFamily: "arial", fontSize: "medium" }}>{selectedSession?.title}</text> */}
            </Modal.Header>
            <Modal.Body >
              <Container fluid="true" className="d-flex row align-items-center text-center p-1">
                <div >
                  {selectedSession?.audio?.url ? (
                    <div>
                      <Card className="rounded-4" style={{ background: '#ebeadf' }}>
                        <Card.Body>
                          {/* <AudioPlayer src={selectedSession?.audio?.url} title={selectedSession.title} onPlaybackUpdate={onPlaybackUpdate} startTime={userTherapySession?.progress ? userTherapySession?.progress : 0} /> */}
                          <AudioPlayer
                            // src={testAudio} 
                            src={selectedSession?.audio?.url}
                            title={selectedSession.title}
                            onPlaybackUpdate={onPlaybackUpdate}
                            onPlaybackEnded={onPlaybackEnded}
                            startTime={userTherapySession?.progress ? userTherapySession?.progress : 0} />
                          <Stack gap={3}>
                            <ButtonToolbar className="mx-auto">
                              <Button className='m-2' onClick={() => setShowThoughtJournal(true)}> <FcSurvey size="24" /> Journal Your Thoughts</Button>
                              <a href='/schedule-appointment' target='_blank'>
                                <Button className='m-2'> <FcCalendar size="24" /> Schedule an Appointment</Button>
                              </a>
                            </ButtonToolbar>

                            {showThoughtJournal ? (

                              <Card>
                                <Card.Body>
                                  <strong>Journal your thoughts for today!<br /> {new Date().toDateString()}</strong>
                                  <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={thought}
                                    onChange={(e) => { setThought(e.target.value); setEnableSaveThoughtBtn(true) }}
                                    className="overflow-auto"
                                  />

                                  <Button className='m-2' disabled={!enableSaveThoughtBtn} onClick={() => { saveThoughtJournal() }}>Save</Button>
                                  <Button className='m-2' onClick={() => { setShowThoughtJournal(false) }}>Cancel</Button>
                                  {displayThoughtJournalAlert ?
                                    (<Alert>{thoughtJournalAlertMessage}</Alert>) : null}
                                </Card.Body>
                              </Card>

                            ) : null

                            }
                          </Stack>
                        </Card.Body>
                      </Card>
                      <Card className="rounded-4" style={{ background: '#ebeadf' }}>
                        <Card.Body className="text-start">
                          <Card.Title className="text-start">Session Summary:</Card.Title>
                          <Card.Text>{selectedSession.summary}</Card.Text>
                          <Card.Title className="text-start">Key Takeaways:</Card.Title>
                          {selectedSession?.takeaways?.map((item) => {
                            return (
                              <>
                                <FcCheckmark /> {item}<br />
                              </>
                            )
                          })}
                        </Card.Body>
                      </Card>
                      {/* <Card autoFocus className="rounded-4" style={{ background: '#ebeadf' }}>
                        <Card.Body className='d-flex justify-content-center'>
                          <Stack gap={3}>

                            <ButtonToolbar className="mx-auto">
                              <Button className='m-2' onClick={() => setShowThoughtJournal(true)}> <FcSurvey size="24" /> Journal Your Thoughts</Button>
                              <a href='/schedule-appointment' target='_blank'>
                                <Button className='m-2'> <FcCalendar size="24" /> Schedule an Appointment</Button>
                              </a>
                            </ButtonToolbar>

                            {showThoughtJournal ? (

                              <Card>
                                <Card.Body>
                                  <strong>Journal your thoughts for today!<br /> {new Date().toDateString()}</strong>
                                  <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={thought}
                                    onChange={(e) => { setThought(e.target.value); setEnableSaveThoughtBtn(true) }}
                                    className="overflow-auto"
                                  />

                                  <Button className='m-2' disabled={!enableSaveThoughtBtn} onClick={() => { saveThoughtJournal() }}>Save</Button>
                                  <Button className='m-2' onClick={() => { setShowThoughtJournal(false) }}>Cancel</Button>
                                  {displayThoughtJournalAlert ?
                                    (<Alert>{thoughtJournalAlertMessage}</Alert>) : null}
                                </Card.Body>
                              </Card>

                            ) : null

                            }
                          </Stack>
                        </Card.Body>
                      </Card> */}
                    </div>

                  ) : (
                    <Alert variant="info">No audio file available.</Alert>
                  )}
                </div>
              </Container>
            </Modal.Body>
          </Modal>) : null
      }

    </>
  );
};

export default SimulatedSessions;